import Section from "@bmi-digital/components/section";
import { replaceSpaces } from "@bmi-digital/components/utils";
import YoutubeVideo from "@bmi-digital/components/youtube-video";
import { graphql } from "gatsby";
import React from "react";
import RichText from "./RichText";
import { StyledVideoWrapper } from "./styles/VideoSection.styles";
import type { RichTextData } from "./RichText";
import type { PayloadVideoSection } from "../types/payload";
import type { VideoVideoSection } from "./video/types";

export type VideoSectionData = Pick<
  PayloadVideoSection,
  "blockType" | "title"
> & {
  richTextDescription: RichTextData | null;
  video: VideoVideoSection;
};

const VideoSection = ({
  data: { title, richTextDescription, video }
}: {
  data: VideoSectionData;
}) => {
  return (
    <Section data-testid={`video-section-${replaceSpaces(title)}`}>
      {title && <Section.Title>{title}</Section.Title>}
      {richTextDescription && (
        <RichText document={richTextDescription} hasNoBottomMargin />
      )}
      <StyledVideoWrapper>
        <YoutubeVideo
          {...video}
          layout="inline"
          previewImageSource={video.defaultYouTubePreviewImage}
          embedHeight={video.videoRatio?.height || 0}
          embedWidth={video.videoRatio?.width || 0}
        />
      </StyledVideoWrapper>
    </Section>
  );
};

export default VideoSection;

export const query = graphql`
  fragment VideoSectionFragment on PayloadVideoSection {
    blockType
    title
    richTextDescription: description {
      ...RichTextFragment
    }
    video {
      ...VideoFragment
    }
  }
`;
